import { render, staticRenderFns } from "./groupEventUserReports.vue?vue&type=template&id=2a1a110e&"
import script from "./groupEventUserReports.vue?vue&type=script&lang=js&"
export * from "./groupEventUserReports.vue?vue&type=script&lang=js&"
import style0 from "./groupEventUserReports.vue?vue&type=style&index=0&id=2a1a110e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports